import React, { useState, useContext } from "react";
import { MODAL_TYPES } from "../constants";
import AudioTestModal from "./AudioTestModal";

const ModalContext = React.createContext(null);

const ModalProvider = ({ children }) => {
  const [modalType, setModalType] = useState();

  const handleOpenModal = (modalType) => {
    setModalType(modalType);
  };

  const handleClose = () => {
    setModalType(null);
  };

  const renderModal = () => {
    switch (modalType) {
      case MODAL_TYPES.AUDIO_TEST:
        return <AudioTestModal onClose={handleClose} />;
      default:
        return null;
    }
  };

  const contextValue = {
    openModal: handleOpenModal,
  };

  return (
    <ModalContext.Provider value={contextValue}>
      {renderModal()}

      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  return useContext(ModalContext);
};

ModalProvider.displayName = "ModalProvider";

export default ModalProvider;
